/* PB Vault — pinned horizontal scroll
   Desktop only (>=1025px). Mobile/tablet falls back to native scroll.
   Loads GSAP + ScrollTrigger lazily from CDN.
*/
(function () {
  'use strict';

  var GSAP_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
  var ST_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-pb-gsap="' + src + '"]')) {
        var poll = setInterval(function () {
          if (window.gsap && (src === GSAP_URL || window.ScrollTrigger)) { clearInterval(poll); resolve(); }
        }, 60);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.dataset.pbGsap = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(GSAP_URL).then(function () { return loadScript(ST_URL); });
  }

  function init(root) {
    if (!root || root.dataset.pbInit === '1') return;
    if (window.innerWidth <= 1024) return;
    root.dataset.pbInit = '1';

    ensureGsap().then(function () {
      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return;
      gsap.registerPlugin(ScrollTrigger);

      var list = root.querySelector('[data-pb-vault-cards]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.pb-vault-card'));
      var intro = root.querySelector('[data-pb-vault-intro]');
      var outro = root.querySelector('[data-pb-vault-outro]');

      if (!list || !cards.length) return;

      var vw = window.innerWidth;
      var pad = vw * 1.2;

      list.style.paddingLeft = pad + 'px';
      list.style.paddingRight = pad + 'px';

      var scrollDist = list.scrollWidth - vw;
      if (scrollDist <= 0) return;

      var mainTween = gsap.to(list, {
        x: -scrollDist,
        ease: 'none',
        scrollTrigger: {
          trigger: root,
          pin: true,
          scrub: true,
          start: 'top top',
          end: '+=' + scrollDist,
          anticipatePin: 1,
          pinSpacing: true,
          invalidateOnRefresh: true
        }
      });

      if (intro && cards[0]) {
        gsap.to(intro, {
          autoAlpha: 0,
          ease: 'none',
          scrollTrigger: {
            containerAnimation: mainTween,
            trigger: cards[0],
            start: 'left 100%',
            end: 'left 50%',
            scrub: true
          }
        });
      }

      if (outro && cards[cards.length - 1]) {
        gsap.set(outro, { autoAlpha: 0, visibility: 'visible' });
        gsap.fromTo(outro, { autoAlpha: 0 }, {
          autoAlpha: 1,
          ease: 'none',
          scrollTrigger: {
            containerAnimation: mainTween,
            trigger: cards[cards.length - 1],
            start: 'right 80%',
            end: 'right 20%',
            scrub: true
          }
        });
      }

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        cards.forEach(function (card) {
          var s = function () { return Math.random() > 0.5 ? 1 : -1; };
          var px = (Math.random() * 20 + 30) * s();
          var py = (Math.random() * 6 + 10) * s();
          var pr = (Math.random() * 10 + 10) * s();
          gsap.fromTo(card,
            { rotation: pr, xPercent: px, yPercent: py },
            {
              rotation: -pr, xPercent: -px, yPercent: -py,
              ease: 'none',
              scrollTrigger: {
                containerAnimation: mainTween,
                trigger: card,
                start: 'left 120%',
                end: 'right -20%',
                scrub: true
              }
            }
          );
        });
      }
    });
  }

  function initAll() { document.querySelectorAll('.pb-vault').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pb-vault');
    if (root) init(root);
  });
})();
